<template>
  <ul class="tree">
    <t-tree-node v-for="(child, index) in root.childNodes" :node="child" :props="props" :key="index" :render-content="renderContent" @node-expand="onNodeExpand">
    </t-tree-node>
    <div v-if="!root.childNodes || root.childNodes.length === 0">
      <span class="el-tree__empty-text">{{ emptyText }}</span>
    </div>
  </ul>
</template>

<script>
import TreeStore from './model/tree-store'
import TTreeNode from './tree-node.vue'
import Emitter from '../../mixins/emitter'

export default {
  name: 'TTree',
  components: {
    TTreeNode
  },
  mixins: [Emitter],
  props: {
    data: {
      type: Array
    },
    emptyText: {
      type: String,
      default() {
        return 'tree node'
      }
    },
    props: {
      type: Object,
      default() {
        return {
          label: 'label',
          children: 'children',
          disabled: 'disabled'
        }
      }
    },
    nodeKey: String,
    checkStrictly: Boolean,
    allExpandable: Boolean,
    expandOnClickNode: {
      type: Boolean,
      default: false
    },
    autoExpandParent: {
      type: Boolean,
      default: true
    },
    defaultCheckedKeys: Array,
    defaultExpandedKeys: Array,
    renderContent: Function,
    isCheck: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    highlightCurrent: Boolean,
    currentNodeKey: [String, Number],
    load: Function,
    filterNodeMethod: Function,
    accordion: Boolean,
    horizontalScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      store: null,
      root: null,
      currentNode: null
    }
  },
  computed: {
    children: {
      set(value) {
        this.data = value
      },
      get() {
        return this.data
      }
    }
  },
  watch: {
    defaultCheckedKeys(newVal) {
      this.store.defaultCheckedKeys = newVal
      this.store.setDefaultCheckedKey(newVal)
    },
    defaultExpandedKeys(newVal) {
      this.store.defaultExpandedKeys = newVal
      this.store.setDefaultExpandedKeys(newVal)
    },
    currentNodeKey(newVal) {
      this.store.setCurrentNodeKey(newVal)
      this.store.currentNodeKey = newVal
    },
    data(newVal) {
      this.store.setData(newVal)
    }
  },
  created() {
    this.isTree = true
    this.store = new TreeStore({
      key: this.nodeKey,
      data: this.data,
      lazy: this.lazy,
      props: this.props,
      load: this.load,
      currentNodeKey: this.currentNodeKey,
      checkStrictly: this.checkStrictly,
      defaultCheckedKeys: this.defaultCheckedKeys,
      defaultExpandedKeys: this.defaultExpandedKeys,
      autoExpandParent: this.autoExpandParent,
      allExpandable: this.allExpandable,
      filterNodeMethod: this.filterNodeMethod,
      horizontalScroll: this.horizontalScroll
    })

    this.root = this.store.root
  },
  methods: {
    // 添加私有方法
    filter(value) {
      if (!this.filterNodeMethod) {
        throw new Error('[Tree] filterNodeMethod is required when filter')
      }
      this.store.filter(value)
    },
    getCheckedNodes(leafOnly) {
      return this.store.getCheckedNodes(leafOnly)
    },
    getCheckedKeys(leafOnly) {
      return this.store.getCheckedKeys(leafOnly)
    },
    getHalfCheckedKeys() {
      return this.store.getHalfCheckedKeys()
    },
    setCheckedNodes(nodes, leafOnly) {
      if (!this.nodeKey) {
        throw new Error('[Tree] nodeKey is required in setCheckedNodes')
      }
      this.store.setCheckedNodes(nodes, leafOnly)
    },
    setCheckedKeys(keys, leafOnly) {
      if (!this.nodeKey) {
        throw new Error('[Tree] nodeKey is required in setCheckedNodes')
      }
      this.store.setCheckedKeys(keys, leafOnly)
    },
    setChecked(data, checked, deep) {
      this.store.setChecked(data, checked, deep)
    },
    onNodeExpand(nodeData, node, instance) {
      this.broadcast('t-tree-node', 'tree-node-expand', node)
      this.$emit('node-expand', nodeData, node, instance)
    },
    expandAll() {
      this.store.expandAll()
    },
    collapseAll() {
      this.store.collapseAll()
    },
    expandById(key) {
      this.store.expandById(key)
    },
    collapseById(key) {
      this.store.collapseById(key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// tree.vue?0538ce40